export default __webpack_public_path__ + "50d9844d2e3b126f762d9a037c23f6b0.png";